// Login der verifizierten Seelsorger. Bleibt dauerhaft auf dem Gerät gespeichert,
// bis über "Log out" abgemeldet wird (oder der Server die Sitzung ablehnt).
import { registerStaffDevice, unregisterStaffDevice } from './staffChat.js'

const API = import.meta.env.VITE_API_URL || ''
const TOKEN_KEY = 'reverend_pastor_token'
const PROFILE_KEY = 'reverend_pastor_profile'

export function readPastorToken() {
  try { return localStorage.getItem(TOKEN_KEY) || '' } catch { return '' }
}

/** { id, username, display_name } oder null */
export function readPastorProfile() {
  try { return readPastorToken() ? JSON.parse(localStorage.getItem(PROFILE_KEY)) : null } catch { return null }
}

function store(token, profile) {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
    } else {
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(PROFILE_KEY)
    }
  } catch { /* Storage nicht verfügbar */ }
}

export function clearPastorSession() {
  store('', null)
}

export async function pastorLogin(username, password) {
  const res = await fetch(`${API}/api/pastor/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || 'Login failed.')
  store(data.token, data.pastor)
  registerStaffDevice()
  return data.pastor
}

export async function pastorLogout() {
  const token = readPastorToken()
  if (token) await unregisterStaffDevice(token)
  clearPastorSession()
  if (!token) return
  try {
    await fetch(`${API}/api/pastor/logout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: '{}',
    })
  } catch { /* lokal ist bereits abgemeldet */ }
}
